import React, { useState } from 'react'
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@material-ui/core'

/**
 * Explains party assignment and field names for the DocuSeal builder.
 * The party dropdown itself lives inside the embed.
 */
export const SignableDocBuilderGuideButton: React.FC = () => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button size="small" onClick={() => setOpen(true)}>
                Placement guide
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Placing fields</DialogTitle>
                <DialogContent>
                    <Typography variant="subtitle2" gutterBottom>
                        Use a different party for each person
                    </Typography>
                    <Typography variant="body2" paragraph>
                        The party menu is Applicant, Property, and Guarantor.
                        Put each box on the person who signs it, or who that
                        value belongs to. Resident boxes, property-manager
                        boxes, and guarantor boxes each get their own party.
                    </Typography>
                    <Box component="ul" pl={2} mt={0} mb={2}>
                        <Typography component="li" variant="body2">
                            <strong>Applicant</strong> — the resident
                        </Typography>
                        <Typography component="li" variant="body2">
                            <strong>Property</strong> — the property manager
                        </Typography>
                        <Typography component="li" variant="body2">
                            <strong>Guarantor</strong> — only when a guarantor
                            signs this document
                        </Typography>
                    </Box>
                    <Typography variant="body2" paragraph>
                        If a box still says First Party or Second Party, change
                        it to one of those three before you save. Those default
                        names are not sent to the right person.
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                        Name fields so you recognize them later
                    </Typography>
                    <Typography variant="body2">
                        After you save, each field shows up in the mapping table
                        under the name you give it. Use a name you will know,
                        such as Resident signature or Monthly rent.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setOpen(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
